var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlay = function SvgPlay(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Play") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unicef-Sub-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Love-Travels---Home-Alt---Desktop",
    transform: "translate(-642, -6385)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(139, 6159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0, 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(503, 214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,0 C8.50658975,0 0,8.50658975 0,19 C0,29.4934102 8.50658975,38 19,38 C29.4934102,38 38,29.4934102 38,19 C38,8.50658975 29.4934102,0 19,0 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#000000",
    points: "14 9 29 19.1437442 14 29"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzhweCIgaGVpZ2h0PSIzOHB4IiB2aWV3Qm94PSIwIDAgMzggMzgiIHZlcnNpb249IjEuMSI+CiAgPHRpdGxlPlBsYXk8L3RpdGxlPgogIDxnIGlkPSJVbmljZWYtU3ViLVBhZ2UiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPGcgaWQ9IkxvdmUtVHJhdmVscy0tLUhvbWUtQWx0LS0tRGVza3RvcCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY0MiwgLTYzODUpIj4KICAgICAgPGcgaWQ9Ikdyb3VwLTM3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMzksIDYxNTkpIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtMzYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAsIDEyKSI+CiAgICAgICAgICA8ZyBpZD0iUGxheSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTAzLCAyMTQpIj4KICAgICAgICAgICAgPHBhdGggZD0iTTE5LDAgQzguNTA2NTg5NzUsMCAwLDguNTA2NTg5NzUgMCwxOSBDMCwyOS40OTM0MTAyIDguNTA2NTg5NzUsMzggMTksMzggQzI5LjQ5MzQxMDIsMzggMzgsMjkuNDkzNDEwMiAzOCwxOSBDMzgsOC41MDY1ODk3NSAyOS40OTM0MTAyLDAgMTksMCBaIiBmaWxsPSIjRkZGRkZGIi8+CiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJSZWN0YW5nbGUiIGZpbGw9IiMwMDAwMDAiIHBvaW50cz0iMTQgOSAyOSAxOS4xNDM3NDQyIDE0IDI5Ii8+CiAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgICA8L2c+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";